export const tranformFormula = (formula: any) => {
  const transformedFormula = formula.map((elem: any) => {
    const obj: any = {}
    if (elem.isData) {
      obj.search = elem.search
    } else {
      elem.children.sort((a: any, b: any) => a.position - b.position)
      const transformedFormulaAux = tranformFormula(elem.children)
      obj[elem.operator] = transformedFormulaAux
    }
    return obj
  })
  return transformedFormula
}
